'use client';

import { useDialog } from '@musinsa/mds-ui';
import { useDeviceInfo } from '@musinsa/packages-device-detection';
import { useCallback } from 'react';
import { getBrandConfig, getPaths, getRestrictionMessage } from '../../common';
import { useNavigate } from '../../common/hooks/useNavigate';
import { useCheckJoinEligibility } from './useCheckJoinEligibility';

export const useJoinEligibilityCheck = () => {
  const { navigate } = useNavigate();
  const dialog = useDialog();
  const { service } = useDeviceInfo();
  const brandConfig = getBrandConfig(service);
  const { refetch, isLoading } = useCheckJoinEligibility();

  const checkEligibilityAndProceed = useCallback(async () => {
    try {
      const { data, error, isError } = await refetch();

      if (isError || error) {
        throw error || new Error('가입 가능 여부 조회 실패');
      }

      if (!data) {
        throw new Error('서버 응답 데이터가 없습니다');
      }

      if (data.eligible) {
        navigate(getPaths(service).join());
      } else {
        const message = getRestrictionMessage(data.restrictionType, brandConfig);
        dialog.open({
          title: '',
          message: message || '가입 신청이 제한되었습니다.',
          confirmButtonText: '확인',
        });
      }
    } catch (_error) {
      dialog.open({
        title: '',
        message: '가입 가능 여부를 확인하는 중 오류가 발생했습니다.\n잠시 후 다시 시도해주세요.',
        confirmButtonText: '확인',
      });
    }
  }, [refetch, navigate, dialog, brandConfig, service]);

  return {
    checkEligibilityAndProceed,
    isLoading,
  };
};
